
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Footer extends Vue {
  // 是否需要显示隐私政策
  @Prop({ default: true })
  needPrivacy?: boolean;

  openPrivacy() {
    window.open("/pdf/隐私政策.pdf", "_blank");
  }
}
